/* Collectie-pagina rendering — leest data/products.json en vult grid */

(async function() {
  const slug = document.body.dataset.collection;
  if (!slug) return;

  const isAll = slug === 'all';

  // ── Title case (Versa data is volledig UPPERCASE) ────────────────────────
  // Gebruik de globale window.SH.titleCase (in site.js) zodat alt-text ook toegankelijk is voor screen readers.
  const toTitleCase = (window.SH && window.SH.titleCase) || function(str) {
    const keep = new Set(['en','in','op','de','het','een','van','voor','met','aan','bij','of','over','uit','als','naar','door']);
    return str.toLowerCase().replace(/[^\s-]+/g, (w, i) =>
      (i === 0 || !keep.has(w)) ? w[0].toUpperCase() + w.slice(1) : w
    );
  };

  // ── Levering badge (canonical helper in site.js) ─────────────
  function getDeliveryLabel() {
    if (window.SH && window.SH.getDeliveryDay) return window.SH.getDeliveryDay().labelInHuis;
    // Fallback: ship-day = today/next werkdag, deliver = ship + 1 werkdag
    const now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' }));
    const d = now.getDay(), h = now.getHours();
    let off;
    if (d === 0) off = 2;
    else if (d === 6) off = 3;
    else if (d === 5 && h >= 12) off = 4;
    else if (d === 5) off = 3;
    else if (h >= 12) off = (d === 4 ? 4 : 2);
    else off = 1;
    const dt = new Date(now); dt.setDate(dt.getDate() + off);
    const days = ['Zondag','Maandag','Dinsdag','Woensdag','Donderdag','Vrijdag','Zaterdag'];
    return days[dt.getDay()] + ' in huis';
  }
  const deliveryLabel = getDeliveryLabel();

  // ── Stijl classificatie (6 categorieën) ──────────────────────────────────
  function getStijl(p) {
    const t = (p.title || '').toUpperCase();
    const colors = (p.colors || []).map(c => c.toLowerCase());
    const brand  = (p.brand  || '').toLowerCase();
    const mats   = (p.materials || []).map(m => m.toLowerCase());
    // Biophilic: natuursteen, hout, fossiel, riviergesteente
    if (mats.some(m => ['natuursteen','hout'].includes(m)) ||
        /\b(RIVIERSTEEN|FOSSIL|NATURAL|NATUUR|BAMBOE|RIET)\b/.test(t)) return 'Biophilic';
    // Spa / Wellness: vrijstaand ligbad, wellness
    if (/\bVRIJSTAAND\b/.test(t) && /\b(BAD|LIGBAD)\b/.test(t)) return 'Spa / Wellness';
    if (/\b(WHIRLPOOL|JACUZZI|SAUNA|STOOM)\b/.test(t)) return 'Spa / Wellness';
    // Japandi: RVS, mat zwart, organisch, Aloni/Bocchi
    if (colors.some(c => ['rvs','eik','walnoot','mat zwart'].includes(c)) ||
        ['aloni','bocchi'].includes(brand) ||
        /\b(RVS|ORGANISCH|TATAMI)\b/.test(t)) return 'Japandi';
    // Warm Modern: koper, goud, gunmetal, eiken
    if (colors.some(c => ['geborsteld goud','geborsteld koper','koper','gunmetal'].includes(c)) ||
        /\b(EIKEN|WARM|GEBORSTELD)\b/.test(t)) return 'Warm Modern';
    // Minimalistisch: mat wit, vierkant, strak
    if (colors.some(c => ['mat wit','wit','mat zwart','zwart'].includes(c)) ||
        /\b(SQUARE|VIERKANT|STRAK|SLANK|FLAT)\b/.test(t)) return 'Minimalistisch';
    // Klassiek: chroom, klassiek, gebogen
    if (colors.some(c => ['chroom','goud'].includes(c)) ||
        /\b(VRIJSTAAND|KLASSIEK|GEBOGEN|STAAND)\b/.test(t)) return 'Klassiek';
    return 'Overig';
  }

  // ── Per-categorie type detectie (aligned met Versa groothandel) ──────────
  function getTypes(p, catSlug) {
    const t = (p.title || '').toUpperCase();
    const mats = (p.materials || []).map(m => m.toLowerCase());
    const types = [];

    if (catSlug === 'kranen') {
      // Primair type
      if (/BIDETKRAAN|BIDET.*KRAAN/.test(t))             types.push('Bidetkraan');
      else if (/WASTAFEL(MENG)?KRAAN/.test(t))            types.push('Wastafelkraan');
      else if (/BADMENGKRAAN|BAD(EN)?KRAAN/.test(t))      types.push('Bad- en douchekraan');
      else if (/DOUCHEKRAAN|DOUCHESPROEIER/.test(t))      types.push('Bad- en douchekraan');
      else if (/KEUKENKRAAN/.test(t))                     types.push('Keukenkraan');
      // Montage
      if (/\bINBOUW\b/.test(t))    types.push('Inbouw');
      if (/\bOPBOUW\b/.test(t))    types.push('Opbouw');
      // Functie
      if (/THERMOSTAAT|THERMOSTATISCH/.test(t))           types.push('Thermostatisch');
      if (/PUSH.?UP/.test(t))                             types.push('Push-up afvoer');

    } else if (catSlug === 'badkamermeubels') {
      // Type meubel
      if (/KOLOMKAST/.test(t))                            types.push('Kolomkast');
      else if (/SPIEGELKAST/.test(t))                     types.push('Spiegelkast');
      else if (/TOILETMEUBEL|TOILET.*MEUBEL/.test(t))     types.push('Toiletmeubel');
      else if (/ONDERKAST/.test(t))                       types.push('Onderkast');
      // Breedte uit titel
      const m = t.match(/\b(40|45|50|60|70|80|90|100|120|140|160)\s*CM\b/);
      if (m) types.push(m[1] + ' cm');

    } else if (catSlug === 'douche') {
      // Type douche-element
      if (/INLOOPDOUCHE/.test(t))                         types.push('Inloopdouche');
      else if (/DOUCHECABINE|CABINE/.test(t))              types.push('Douchecabine');
      else if (/DOUCHEWAND/.test(t))                       types.push('Douchewand');
      else if (/BADWAND/.test(t))                          types.push('Badwand');
      else if (/DOUCHEBAK/.test(t))                        types.push('Douchebak');
      else if (/REGENDOUCHE/.test(t))                      types.push('Doucheset & koppen');
      else if (/DOUCHESET|DOUCHEKOP/.test(t))              types.push('Doucheset & koppen');
      // Glas
      if (/MAT\s*GLAS/.test(t))                           types.push('Mat glas');
      else if (/HELDER\s*GLAS/.test(t))                   types.push('Helder glas');

    } else if (catSlug === 'toiletten') {
      // Type toilet
      if (/HANGTOILET.*RANDLOOS|RANDLOOS.*HANGTOILET/.test(t)) types.push('Hangtoilet randloos');
      else if (/HANGTOILET|OPHANG/.test(t))               types.push('Hangtoilet');
      else if (/STAAND/.test(t))                          types.push('Staand toilet');
      if (/BIDET/.test(t))                                types.push('Bidet functie');
      if (/URINOIR/.test(t))                              types.push('Urinoir');
      if (/BEDIENINGSPANEEL/.test(t))                     types.push('Bedieningspaneel');
      if (/INBOUWRESERVOIR|INBOUWELEMENT|INBOUWFRAME/.test(t)) types.push('Inbouwreservoir');
      if (/\bZITTING\b/.test(t))                          types.push('WC-zitting');

    } else if (catSlug === 'wastafels') {
      // Montagetype
      if (/OPBOUW|WASKOM/.test(t))                        types.push('Opbouw wastafel');
      else if (/\bINBOUW\b/.test(t))                      types.push('Inbouw wastafel');
      else if (/WASTAFELBLAD/.test(t))                    types.push('Wastafelblad');
      // Materiaal
      if (mats.includes('solid surface') || /SOLID\s*SURFACE/.test(t)) types.push('Solid surface');
      if (mats.includes('natuursteen') || /NATUUR|STEEN|RIVIERSTEEN/.test(t)) types.push('Natuursteen');
    }
    return types;
  }

  try {
    const [productsRes, collectionsRes, flatRes] = await Promise.all([
      fetch('/data/products.json'),
      fetch('/data/collections.json'),
      isAll ? fetch('/data/products-flat.json') : Promise.resolve(null),
    ]);
    // Data layer down (e.g. /data/*.json 404) → leave the server-rendered grid
    // intact and let sh-load-more.js handle pagination. Clean return (not a
    // throw) so we never wipe the SSR grid or kill the working load-more.
    // Filters/sort are unavailable in this degraded mode (they need the data),
    // but the page stays usable instead of silently breaking.
    if (!productsRes.ok || !collectionsRes.ok || (isAll && (!flatRes || !flatRes.ok))) {
      console.warn('[collection] /data/*.json unavailable — server grid + sh-load-more fallback');
      return;
    }
    const allProducts = await productsRes.json();
    const collections = await collectionsRes.json();
    const products = isAll
      ? (await flatRes.json()).slice()
      : (allProducts[slug] || []).slice();

    // Stijl + type tags toevoegen
    products.forEach(p => {
      p._stijl = getStijl(p);
      p._types = getTypes(p, slug);
    });

    products.sort((a, b) => {
      const ra = a.featured_rank || 3, rb = b.featured_rank || 3;
      if (ra !== rb) return ra - rb;
      return (b.price || 0) - (a.price || 0);
    });

    // ── Assortiment-hero: top-9 populair, max 2 per categorie, voorkeur compare_at ──
    if (isAll) {
      const candidates = products
        .filter(p => p.featured_rank === 1 && p.available !== false)
        .slice()
        .sort((a, b) => {
          // 1. Producten met kortingsanker eerst
          const aDeal = a.compare_at && a.compare_at > a.price ? 0 : 1;
          const bDeal = b.compare_at && b.compare_at > b.price ? 0 : 1;
          if (aDeal !== bDeal) return aDeal - bDeal;
          // 2. Binnen elke groep: rank ASC, dan price DESC
          return (b.price || 0) - (a.price || 0);
        });
      const hero = [];
      const perCol = {};
      for (const p of candidates) {
        if (hero.length >= 9) break;
        const n = perCol[p.collection] || 0;
        if (n < 2) { hero.push(p); perCol[p.collection] = n + 1; }
      }
      if (hero.length === 9) {
        const heroSet = new Set(hero.map(p => p.handle));
        const rest = products.filter(p => !heroSet.has(p.handle));
        products.length = 0;
        products.push(...hero, ...rest);
      }
    }

    // ── Japandi Edition strip ─────────────────────────────────────────────────
    const stripTitles = {
      kranen:          'Japandi Kranen — Mat Zwart & Warm Design',
      badkamermeubels: 'Japandi Badkamermeubelen',
      wastafels:       'Design Wastafels',
      douche:          'Japandi Inloopdouches',
      spiegels:        'Japandi LED-Spiegels',
      radiatoren:      'Japandi Design Radiatoren',
      toiletten:       'Bestseller Toiletten',
      accessoires:     'Japandi Accessoires',
      baden:           'Design Baden',
    };
    const stripGrid  = document.getElementById('strip-grid');
    const stripTitle = document.querySelector('[data-strip-title]');
    const _isSubPage = !!document.body.dataset.sub;
    if (_isSubPage) {
      // Subpages tonen geen parent-bestseller-strip — eigen sub-grid is al de focus
      document.getElementById('japandi-strip')?.remove();
    } else if (stripGrid && stripTitle && !isAll) {
      stripTitle.textContent = stripTitles[slug] || 'Japandi Editie';
      const stripProds = products.filter(p => p.featured_rank === 1 && p.available !== false).slice(0, 8);
      if (stripProds.length === 0) {
        document.getElementById('japandi-strip')?.remove();
      } else {
        stripGrid.innerHTML = stripProds.map(p => `
          <a href="/products/${p.handle}/" class="snap-start shrink-0 w-[200px] md:w-auto group block relative">
            <div class="relative rounded-[16px] bg-[color:var(--paper)] aspect-[4/5] overflow-hidden flex items-center justify-center p-6 md:p-8">
              <img src="${p.image}" alt="${toTitleCase(p.title)}" class="w-full h-full object-contain transition-transform duration-300 group-hover:scale-105" loading="lazy" />
              ${p.compare_at && p.compare_at > p.price
                ? `<div class="absolute top-3 left-3 px-2.5 py-1 bg-[color:var(--clay)] text-bone text-[10px] tracking-[0.15em] uppercase rounded-full">-${Math.round((1-p.price/p.compare_at)*100)}%</div>`
                : `<div class="absolute top-3 left-3 px-2.5 py-1 bg-[color:var(--moss)] text-bone text-[10px] tracking-[0.12em] uppercase rounded-full pointer-events-none">${deliveryLabel}</div>`
              }
            </div>
            <div class="pt-3">
              <p class="text-[11px] tracking-editorial text-[color:var(--muted)]">${p.brand}</p>
              <h3 class="font-display text-[15px] display-tight line-clamp-2 mt-0.5 text-ink">${toTitleCase(p.title)}</h3>
              ${p.compare_at && p.compare_at > p.price
                ? `<div class="mt-1.5">
                     <div class="flex items-baseline gap-1.5 flex-wrap">
                       <span class="price-advice-label">Adviesprijs</span>
                       <span class="price-advice text-[12px]">&euro;${p.compare_at.toFixed(0)}</span>
                     </div>
                     <p class="text-[15px] font-semibold text-ink mt-0.5">&euro;${p.price.toFixed(0)}</p>
                   </div>`
                : `<p class="text-[14px] font-medium mt-1 text-ink">${p.price ? '€'+p.price.toFixed(0) : 'Op aanvraag'}</p>`
              }
              <p class="mt-1.5 text-[10.5px] tracking-[0.14em] uppercase text-[color:var(--moss)] flex items-center gap-1.5 whitespace-nowrap">
                <svg class="w-3 h-3 shrink-0" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M5 13l4 4L19 7"/></svg>
                ${deliveryLabel}
              </p>
            </div>
          </a>`).join('');
      }
    } else {
      document.getElementById('japandi-strip')?.remove();
    }

    const meta = isAll
      ? { titel: 'Assortiment', desc: 'Alle producten in één overzicht — filter links op collectie, prijs of merk.' }
      : (collections.find((c) => c.slug === slug) || { titel: slug, desc: '' });

    // SSR-content (sub-pagina's én SSR'd parents) niet overschrijven — beter voor SEO
    const skipMetaOverride = !!document.body.dataset.sub
      || !!document.querySelector('[data-col-ssr="1"]');
    if (!skipMetaOverride) {
      document.querySelectorAll('[data-col-titel]').forEach((el) => el.textContent = meta.titel);
      document.querySelectorAll('[data-col-desc]').forEach((el) => el.textContent = meta.desc);
      document.querySelectorAll('[data-col-count]').forEach((el) => el.textContent = products.length);

      if (!isAll && meta.titel) {
        const t = document.querySelector('title');
        if (t && /sanizone/i.test(t.textContent)) t.textContent = meta.titel + ' — SaniZone';
        const md = document.querySelector('meta[name="description"]');
        if (md) md.setAttribute('content', (meta.desc || `${meta.titel} — gecureerde selectie`) + ' · Voor 12:00 besteld morgen in huis · Gratis verzending vanaf €100.');
      }
    }

    // Editorial enrichment (SEO + content-depth)
    renderEditorial(slug, meta);

    // Category filter (alleen /all/)
    const categoryBox = document.getElementById('category-filter');
    if (isAll && categoryBox) {
      const cats = [
        {slug:'kranen',title:'Kranen'},{slug:'badkamermeubels',title:'Meubels'},
        {slug:'wastafels',title:'Wastafels'},{slug:'baden',title:'Baden'},
        {slug:'douche',title:'Douche'},{slug:'spiegels',title:'Spiegels'},
        {slug:'radiatoren',title:'Radiatoren'},{slug:'toiletten',title:'Toiletten'},
        {slug:'accessoires',title:'Accessoires'},
      ];
      const counts = {};
      products.forEach(p => { counts[p.collection] = (counts[p.collection]||0)+1; });
      categoryBox.innerHTML = cats.map(c => `
        <label class="flex items-center justify-between py-1.5 cursor-pointer text-[14px] text-[color:var(--ink-soft)] hover:text-ink">
          <span class="flex items-center gap-2">
            <input type="checkbox" class="accent-[color:var(--moss)]" value="${c.slug}" data-filter="category" />
            ${c.title}
          </span>
          <span class="text-[12px] text-[color:var(--muted)]">${counts[c.slug]||0}</span>
        </label>`).join('');
    }

    // JSON-LD (skip op sub-pagina's — die hebben SSR JSON-LD)
    if (!skipMetaOverride) try {
      const site = 'https://sanizone.nl';
      const s = document.createElement('script');
      s.type = 'application/ld+json';
      s.textContent = JSON.stringify({
        "@context":"https://schema.org","@type":"CollectionPage",
        "name":meta.titel,"description":meta.desc,"url":site+location.pathname,
        "mainEntity":{"@type":"ItemList","numberOfItems":products.length,
          "itemListElement":products.slice(0,20).map((p,i)=>({
            "@type":"ListItem","position":i+1,"item":{
              "@type":"Product","name":p.title,"image":p.image,
              "brand":{"@type":"Brand","name":p.brand},
              "url":site+'/products/'+p.handle+'/',
              "offers":{"@type":"Offer","price":p.price,"priceCurrency":"EUR",
                "availability":"https://schema.org/InStock"}
            }
          }))}
      });
      document.head.appendChild(s);
    } catch(e) {}

    // ── Subcategorie-strip (filter via ?sub= of via /collections/<parent>/<sub>/) ─
    let currentSub = null;
    const subcatBucket = new Map();
    let subData = null;
    const isSubPage = !!document.body.dataset.sub;
    if (!isAll) {
      try {
        const subRes = await fetch('/data/subcollections.json');
        if (subRes.ok) {
          const all = await subRes.json();
          subData = all.find(x => x.parent === slug) || null;
        }
      } catch (e) { /* silent */ }
    }

    if (subData && subData.subs && subData.subs.length >= 2) {
      subData.subs.forEach(s => subcatBucket.set(s.slug, new Set(s.product_ids)));

      const params = new URLSearchParams(location.search);
      const bodySub = document.body.dataset.sub || '';
      const initialSub = bodySub || params.get('sub');
      if (initialSub && subcatBucket.has(initialSub)) currentSub = initialSub;

      const stripEl = document.getElementById('subcat-strip');
      const sectionEl = document.getElementById('subcat-section');
      if (stripEl && sectionEl) {
        sectionEl.hidden = false;

        // Overig heeft geen statische SEO-pagina; gebruik parent + ?sub=overig
        const subHref = (sSlug) => {
          if (!sSlug) return `/collections/${slug}/`;
          if (sSlug === 'overig') return `/collections/${slug}/?sub=overig`;
          return `/collections/${slug}/${sSlug}/`;
        };
        const tileHTML = (sSlug, title, count, img, isActive) => `
          <a href="${subHref(sSlug)}" data-subcat="${sSlug}" aria-current="${isActive ? 'page' : 'false'}" class="subcat-tile${isActive ? ' is-active' : ''}">
            <span class="subcat-tile__media">${img ? `<img src="${img}" alt="" loading="lazy" />` : ''}</span>
            <span class="subcat-tile__label">${title}</span>
            <span class="subcat-tile__count">${count} items</span>
          </a>`;

        const allCover = products[0]?.image || '';
        const tiles = [
          tileHTML('', `Alle ${meta.titel}`, products.length, allCover, !currentSub),
          ...subData.subs.map(s => tileHTML(s.slug, s.title, s.count, s.cover_fallback || s.cover_image, s.slug === currentSub)),
        ];
        stripEl.innerHTML = tiles.join('');

        const clearLink = sectionEl.querySelector('[data-subcat-clear]');
        const updateActiveTiles = () => {
          stripEl.querySelectorAll('[data-subcat]').forEach(b => {
            const isActive = (!b.dataset.subcat && !currentSub) || (b.dataset.subcat === currentSub);
            b.classList.toggle('is-active', isActive);
            b.setAttribute('aria-pressed', String(isActive));
          });
          if (clearLink) clearLink.classList.toggle('hidden', !currentSub);
        };

        if (clearLink) {
          if (isSubPage) {
            clearLink.setAttribute('href', `/collections/${slug}/`);
          } else {
            clearLink.addEventListener('click', (e) => {
              e.preventDefault();
              currentSub = null;
              const url = new URL(location.href);
              url.searchParams.delete('sub');
              history.replaceState(null, '', url);
              updateActiveTiles();
              updateCanonical();
              if (typeof apply === 'function') apply();
            });
          }
        }

        const updateCanonical = () => {
          let canonical = document.querySelector('link[rel="canonical"]');
          if (!canonical) {
            canonical = document.createElement('link');
            canonical.rel = 'canonical';
            document.head.appendChild(canonical);
          }
          const baseUrl = `https://sanizone.nl/collections/${slug}/`;
          canonical.href = currentSub ? `${baseUrl}${currentSub}/` : baseUrl;
        };
        updateCanonical();

        // Op sub-pagina's: laat anchors gewoon navigeren naar /collections/<parent>/<sub>/
        // Op parent: intercept en filter in-place via ?sub=
        if (!isSubPage) {
          stripEl.addEventListener('click', (e) => {
            const btn = e.target.closest('[data-subcat]');
            if (!btn) return;
            // Allow modifier-keys / middle-click to navigate normally
            if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
            e.preventDefault();
            currentSub = btn.dataset.subcat || null;
            const url = new URL(location.href);
            if (currentSub) url.searchParams.set('sub', currentSub);
            else url.searchParams.delete('sub');
            history.replaceState(null, '', url);
            updateActiveTiles();
            updateCanonical();
            if (typeof apply === 'function') apply();

            // Smooth-scroll zodat de gefilterde grid direct in beeld komt
            if (currentSub) {
              const grid = document.getElementById('products-grid');
              if (grid) {
                const top = grid.getBoundingClientRect().top + window.scrollY - 120;
                window.scrollTo({ top, behavior: 'smooth' });
              }
            }
          });
        }
      }
    }

    // AI sticky banner — verschijnt pas bij scroll-depth >50% en na 30s, met persistente dismiss
    function maybeShowAIBanner() {
      if (document.getElementById('ai-sticky-banner')) return;
      if (localStorage.getItem('ai-banner-dismissed-perm')) return;
      if (sessionStorage.getItem('ai-banner-dismissed')) return;
      const scrollPct = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight;
      if (scrollPct < 0.5) return;
      const banner = document.createElement('div');
      banner.id = 'ai-sticky-banner';
      banner.className = 'fixed bottom-5 left-4 right-4 md:left-auto md:right-6 md:max-w-[360px] z-30';
      banner.innerHTML = `<a href="/redesign/" class="relative group flex items-center gap-3 p-3.5 rounded-2xl bg-ink text-bone shadow-drop hover:shadow-lift transition-all hover:-translate-y-0.5">
        <div class="w-10 h-10 shrink-0 rounded-xl bg-[color:var(--sage)]/25 flex items-center justify-center text-[color:var(--sage)]">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="9" cy="9" r="2"/><path d="m21 15-5-5L5 21"/></svg>
        </div>
        <div class="flex-1 min-w-0 pr-6">
          <p class="text-[13px] font-semibold leading-tight">Twijfel tussen afwerkingen?</p>
          <p class="text-[11px] opacity-70 leading-tight mt-0.5">Visualiseer ze in jouw ruimte · 30 sec</p>
        </div>
        <svg class="w-4 h-4 opacity-70 group-hover:translate-x-0.5 transition" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M5 12h14M13 5l7 7-7 7"/></svg>
        <button type="button" aria-label="Sluit" class="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-ink text-bone border border-[rgba(250,250,247,0.2)] flex items-center justify-center hover:bg-bone hover:text-ink transition" onclick="event.preventDefault();event.stopPropagation();this.closest('#ai-sticky-banner').remove();localStorage.setItem('ai-banner-dismissed-perm','1');sessionStorage.setItem('ai-banner-dismissed','1')">
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" stroke-width="2.4" viewBox="0 0 24 24"><path d="M6 6l12 12M6 18L18 6"/></svg>
        </button></a>`;
      document.body.appendChild(banner);
    }
    setTimeout(() => {
      maybeShowAIBanner();
      window.addEventListener('scroll', () => {
        // Throttle: alleen als nog niet zichtbaar én niet dismissed
        if (!document.getElementById('ai-sticky-banner')) maybeShowAIBanner();
      }, { passive: true });
    }, 30000);

    const grid = document.getElementById('products-grid');
    if (!grid) return;

    // ── Client-side pagination ("Laad nog X meer") ───────────────────────────
    // renderCards dumps the full collection into the grid, so the server-side
    // {% paginate %} link/nav are dead (a click just reloads ?page=N and the JS
    // re-renders the same list). We window the render in chunks and drive the
    // button in-place instead. The server nav stays as a no-JS fallback only.
    const LOAD_STEP = 24;
    let visibleCount = LOAD_STEP;
    let lastRendered = [];
    // Target the existing server-rendered pagination markup (no Liquid hooks
    // required). Falls back to data-attributes if the section is updated later.
    const loadMoreBtn = document.querySelector('[data-load-more]')
      || (grid.parentElement && grid.parentElement.querySelector('a.cta-pill[href*="page="]'));
    const loadMoreWrap = loadMoreBtn
      ? (loadMoreBtn.closest('[data-load-more-wrap]') || loadMoreBtn.parentElement)
      : null;
    const serverPagination = document.querySelector('[data-server-pagination]')
      || document.querySelector('nav[aria-label="Paginering"]');
    // JS paginates in-place, so the server page-nav is just a no-JS fallback.
    if (serverPagination) serverPagination.classList.add('hidden');
    // Preserve the chevron icon when we rewrite the button label.
    const loadMoreIcon = loadMoreBtn ? (loadMoreBtn.querySelector('svg') || {}).outerHTML || '' : '';

    function updateLoadMore() {
      if (!loadMoreWrap || !loadMoreBtn) return;
      const remaining = lastRendered.length - visibleCount;
      if (remaining > 0) {
        const next = Math.min(LOAD_STEP, remaining);
        const label = loadMoreBtn.querySelector('[data-load-more-label]');
        if (label) label.textContent = `Laad nog ${next} meer`;
        else loadMoreBtn.innerHTML = `Laad nog ${next} meer ${loadMoreIcon}`;
        loadMoreWrap.classList.remove('hidden');
      } else {
        loadMoreWrap.classList.add('hidden');
      }
    }

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', (e) => {
        // Modifier/middle-click → let the fallback link navigate normally
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
        e.preventDefault();
        appendMore();
      });
    }

    if (products.length === 0) {
      grid.innerHTML = `<div class="col-span-full py-16 text-center">
        <p class="tracking-editorial text-[color:var(--muted)] mb-4">Binnenkort</p>
        <h2 class="font-display display-tight text-[28px] md:text-[36px] text-ink max-w-[520px] mx-auto">Deze collectie wordt momenteel samengesteld.</h2>
        <div class="mt-8 flex flex-wrap gap-3 justify-center">
          <a href="/collections/" class="cta-pill">Naar alle collecties <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M5 12h14M13 5l7 7-7 7"/></svg></a>
          <a href="/scan/" class="cta-outline">Wellness-scan</a>
        </div></div>`;
      return;
    }

    // ── Render cards ─────────────────────────────────────────────────────────
    function observeReveal() {
      if (!window.IntersectionObserver) return;
      const io = new IntersectionObserver((es)=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}}),{threshold:0.1});
      grid.querySelectorAll('.reveal:not(.in)').forEach(el=>io.observe(el));
    }

    // i = absolute index in the list (drives the "Nieuw" badge on the first 3).
    function productCardHTML(p, i) {
      return `
        <a href="/products/${p.handle}/" class="group block product-card reveal">
          <div class="relative rounded-[20px] overflow-hidden bg-[color:var(--paper)] aspect-[4/5]">
            <div class="absolute inset-0 flex items-center justify-center p-8 md:p-12">
              <img src="${p.image}" alt="${toTitleCase(p.title)}" class="w-full h-full object-contain card-img" loading="lazy" />
            </div>
            ${p.available === false
              ? `<div class="absolute inset-0 bg-white/40 rounded-[20px]"></div><div class="absolute top-4 left-4 px-3 py-1 bg-ink/80 text-bone text-[11px] tracking-[0.15em] uppercase rounded-full">Uitverkocht</div>`
              : p.compare_at && p.compare_at > p.price
                ? `<div class="absolute top-4 left-4 px-3 py-1 bg-[color:var(--clay)] text-bone text-[11px] tracking-[0.15em] uppercase rounded-full">-${Math.round((1-p.price/p.compare_at)*100)}%</div>`
                : (i < 3 ? `<div class="absolute top-4 left-4 px-3 py-1 bg-bone/90 backdrop-blur text-[11px] tracking-[0.15em] uppercase text-ink rounded-full">Nieuw</div>` : '')}
            ${p.available !== false ? `<div class="absolute top-4 right-4 px-3 py-1 bg-[color:var(--moss)] text-bone text-[11px] tracking-[0.12em] uppercase rounded-full pointer-events-none">${deliveryLabel}</div>` : ''}
            ${p.available !== false ? `<button data-add-to-cart='${JSON.stringify({handle:p.handle,title:p.title,price:p.price,compare_at:p.compare_at||null,image:p.image,brand:p.brand}).replace(/'/g,"&apos;")}' class="absolute bottom-4 right-4 w-11 h-11 md:w-10 md:h-10 rounded-full bg-ink text-bone flex items-center justify-center md:opacity-0 md:group-hover:opacity-100 md:translate-y-2 md:group-hover:translate-y-0 transition shadow-lift" aria-label="In winkelmand">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M12 5v14M5 12h14"/></svg>
            </button>` : ''}
          </div>
          <div class="pt-4 flex items-start justify-between gap-3">
            <div class="min-w-0">
              <p class="tracking-editorial text-[color:var(--muted)]">${p.brand}</p>
              <h3 class="font-display text-[17px] md:text-[19px] display-tight text-ink mt-1 line-clamp-2">${toTitleCase(p.title)}</h3>
            </div>
            <div class="text-right shrink-0">
              ${p.compare_at && p.compare_at > p.price
                ? `<div class="flex items-baseline justify-end gap-1.5 flex-wrap">
                     <span class="price-advice-label">Adviesprijs</span>
                     <span class="price-advice text-[12px]">&euro;${p.compare_at.toFixed(0)}</span>
                   </div>
                   <p class="font-semibold text-[17px] text-ink">&euro;${p.price.toFixed(0)}</p>`
                : `<p class="font-medium text-[16px] text-ink">${p.price ? '€'+p.price.toFixed(0) : '<span class="text-[13px] text-[color:var(--muted)]">Prijs op aanvraag</span>'}</p>`
              }
            </div>
          </div>
        </a>`;
    }

    // Full (re)render — resets the grid to the first `visibleCount` cards.
    function renderCards(list) {
      lastRendered = list;
      grid.innerHTML = list.slice(0, visibleCount).map(productCardHTML).join('');
      observeReveal();
      updateLoadMore();
    }

    // Reveal the next chunk by appending only the new cards (no re-render, so
    // already-visible cards don't re-animate and scroll position is preserved).
    function appendMore() {
      const start = visibleCount;
      visibleCount += LOAD_STEP;
      const slice = lastRendered.slice(start, visibleCount);
      if (slice.length) {
        grid.insertAdjacentHTML('beforeend', slice.map((p, k) => productCardHTML(p, start + k)).join(''));
        observeReveal();
      }
      updateLoadMore();
    }

    let current = products.slice().sort((a,b)=>(a.available===false?1:0)-(b.available===false?1:0));
    renderCards(current);
    // Signal that client-render + the in-memory load-more are live, so the
    // standalone sh-load-more.js fallback stands down (avoids double pagination).
    document.body.dataset.clientPaginated = '1';

    // ── Merk filter met aantallen ─────────────────────────────────────────────
    const brandBox = document.getElementById('brand-filter');
    if (brandBox) {
      const brandCount = {};
      products.forEach(p => { brandCount[p.brand] = (brandCount[p.brand]||0)+1; });
      const brands = Object.keys(brandCount).sort();
      brandBox.innerHTML = brands.map(b => `
        <label class="flex items-center justify-between py-1.5 cursor-pointer text-[14px] text-[color:var(--ink-soft)] hover:text-ink">
          <span class="flex items-center gap-2">
            <input type="checkbox" class="accent-[color:var(--moss)]" value="${b}" data-filter="brand" />
            ${b}
          </span>
          <span class="text-[12px] text-[color:var(--muted)]">${brandCount[b]}</span>
        </label>`).join('');
    }

    // ── Kleur filter ──────────────────────────────────────────────────────────
    const colorBox = document.getElementById('color-filter');
    if (colorBox) {
      const colorCount = {};
      products.forEach(p => (p.colors||[]).forEach(c=>{ colorCount[c]=(colorCount[c]||0)+1; }));
      const orderedColors = ['Chroom','Mat zwart','Mat wit','Wit','Zwart','Geborsteld goud','Goud','Geborsteld koper','Koper','Gunmetal','Grijs','Antraciet','RVS','Marmer','Eik','Walnoot'].filter(c=>colorCount[c]);
      if (!orderedColors.length) colorBox.closest('[data-filter-group]')?.classList.add('hidden');
      else colorBox.innerHTML = orderedColors.map(c => `
        <label class="flex items-center justify-between py-1.5 cursor-pointer text-[14px] text-[color:var(--ink-soft)] hover:text-ink">
          <span class="flex items-center gap-2"><input type="checkbox" class="accent-[color:var(--moss)]" value="${c}" data-filter="color" />${c}</span>
          <span class="text-[12px] text-[color:var(--muted)]">${colorCount[c]}</span>
        </label>`).join('');
    }

    // ── Materiaal filter ──────────────────────────────────────────────────────
    const materialBox = document.getElementById('material-filter');
    if (materialBox) {
      const matCount = {};
      products.forEach(p => (p.materials||[]).forEach(m=>{ matCount[m]=(matCount[m]||0)+1; }));
      const ordered = ['Keramiek','Solid surface','Acryl','Natuursteen','Glas','Messing','Hout','MDF'].filter(m=>matCount[m]);
      if (!ordered.length) materialBox.closest('[data-filter-group]')?.classList.add('hidden');
      else materialBox.innerHTML = ordered.map(m => `
        <label class="flex items-center justify-between py-1.5 cursor-pointer text-[14px] text-[color:var(--ink-soft)] hover:text-ink">
          <span class="flex items-center gap-2"><input type="checkbox" class="accent-[color:var(--moss)]" value="${m}" data-filter="material" /></span>
          <span class="text-[12px] text-[color:var(--muted)]">${matCount[m]}</span>
        </label>`).join('');
    }

    // ── Stijl filter ──────────────────────────────────────────────────────────
    const stijlBox = document.getElementById('stijl-filter');
    if (stijlBox) {
      const stijlKleuren = {
        'Japandi':        '#5C6B5A',
        'Warm Modern':    '#C4956A',
        'Spa / Wellness': '#7BA7BC',
        'Biophilic':      '#8B7355',
        'Minimalistisch': '#A0A0A0',
        'Klassiek':       '#C8B89A',
      };
      const stijlCount = {};
      products.forEach(p => { stijlCount[p._stijl] = (stijlCount[p._stijl]||0)+1; });
      const stijlen = ['Japandi','Warm Modern','Spa / Wellness','Biophilic','Minimalistisch','Klassiek'].filter(s => stijlCount[s]);
      if (!stijlen.length) stijlBox.closest('[data-filter-group]')?.classList.add('hidden');
      else stijlBox.innerHTML = stijlen.map(s => `
        <label class="flex items-center justify-between py-1.5 cursor-pointer text-[14px] text-[color:var(--ink-soft)] hover:text-ink">
          <span class="flex items-center gap-2">
            <span class="inline-block w-2.5 h-2.5 rounded-full shrink-0" style="background:${stijlKleuren[s]||'#ccc'}"></span>
            <input type="checkbox" class="accent-[color:var(--moss)]" value="${s}" data-filter="stijl" />${s}
          </span>
          <span class="text-[12px] text-[color:var(--muted)]">${stijlCount[s]}</span>
        </label>`).join('');
    }

    // ── Per-categorie type filter ─────────────────────────────────────────────
    const typeBox = document.getElementById('type-filter');
    if (typeBox) {
      const typeCount = {};
      products.forEach(p => p._types.forEach(t => { typeCount[t]=(typeCount[t]||0)+1; }));
      const types = Object.keys(typeCount).sort();
      if (!types.length) typeBox.closest('[data-filter-group]')?.classList.add('hidden');
      else typeBox.innerHTML = types.map(t => `
        <label class="flex items-center justify-between py-1.5 cursor-pointer text-[14px] text-[color:var(--ink-soft)] hover:text-ink">
          <span class="flex items-center gap-2"><input type="checkbox" class="accent-[color:var(--moss)]" value="${t}" data-filter="type" />${t}</span>
          <span class="text-[12px] text-[color:var(--muted)]">${typeCount[t]}</span>
        </label>`).join('');
    }

    // ── Budget brackets ───────────────────────────────────────────────────────
    document.querySelectorAll('[data-budget]').forEach(btn => {
      btn.addEventListener('click', () => {
        const [min, max] = btn.dataset.budget.split('-').map(Number);
        const minEl = document.getElementById('price-min');
        const maxEl = document.getElementById('price-max');
        // Toggle: als al actief, wis dan
        const active = btn.classList.contains('bg-ink');
        document.querySelectorAll('[data-budget]').forEach(b => b.classList.remove('bg-ink','text-bone'));
        if (!active) {
          btn.classList.add('bg-ink','text-bone');
          if (minEl) minEl.value = min || '';
          if (maxEl) maxEl.value = max || '';
        } else {
          if (minEl) minEl.value = '';
          if (maxEl) maxEl.value = '';
        }
        apply();
      });
    });

    // ── Apply (filters + sort) ────────────────────────────────────────────────
    function apply() {
      const sort           = document.getElementById('sort')?.value || 'relevant';
      const activeBrands   = Array.from(document.querySelectorAll('[data-filter="brand"]:checked')).map(i=>i.value);
      const activeCats     = Array.from(document.querySelectorAll('[data-filter="category"]:checked')).map(i=>i.value);
      const activeColors   = Array.from(document.querySelectorAll('[data-filter="color"]:checked')).map(i=>i.value);
      const activeMats     = Array.from(document.querySelectorAll('[data-filter="material"]:checked')).map(i=>i.value);
      const activeStijlen  = Array.from(document.querySelectorAll('[data-filter="stijl"]:checked')).map(i=>i.value);
      const activeTypes    = Array.from(document.querySelectorAll('[data-filter="type"]:checked')).map(i=>i.value);
      const priceMin = parseFloat(document.getElementById('price-min')?.value || 0);
      const priceMax = parseFloat(document.getElementById('price-max')?.value || 999999);

      const subBucket = currentSub ? subcatBucket.get(currentSub) : null;
      current = products.filter(p =>
        (!subBucket || subBucket.has(p.id)) &&
        (activeBrands.length  === 0 || activeBrands.includes(p.brand)) &&
        (activeCats.length    === 0 || activeCats.includes(p.collection)) &&
        (activeColors.length  === 0 || (p.colors   && p.colors.some(c   => activeColors.includes(c)))) &&
        (activeMats.length    === 0 || (p.materials && p.materials.some(m => activeMats.includes(m)))) &&
        (activeStijlen.length === 0 || activeStijlen.includes(p._stijl)) &&
        (activeTypes.length   === 0 || p._types.some(t => activeTypes.includes(t))) &&
        (!p.price || (p.price >= priceMin && p.price <= priceMax))
      );

      if (sort === 'relevant' || sort === 'populair') {
        current.sort((a,b)=>{ const ra=a.featured_rank||3,rb=b.featured_rank||3; if(ra!==rb)return ra-rb; return(b.price||0)-(a.price||0); });
      }
      if (sort === 'price-asc')  current.sort((a,b)=>(a.price||0)-(b.price||0));
      if (sort === 'price-desc') current.sort((a,b)=>(b.price||0)-(a.price||0));
      if (sort === 'naam')       current.sort((a,b)=>a.title.localeCompare(b.title));
      current.sort((a,b)=>(a.available===false?1:0)-(b.available===false?1:0));

      // A new filter/sort result starts a fresh window of LOAD_STEP cards.
      visibleCount = LOAD_STEP;
      renderCards(current);
      document.querySelectorAll('[data-col-count-filtered]').forEach(el => el.textContent = current.length);

      // M6 — Filter-summary chips boven de grid
      renderFilterChips({
        brand: activeBrands, category: activeCats, color: activeColors,
        material: activeMats, stijl: activeStijlen, type: activeTypes,
        priceMin: priceMin > 0 ? priceMin : null,
        priceMax: priceMax < 999999 ? priceMax : null,
      });

      // L4 — Mobile filter-drawer "Toon X resultaten"-CTA
      const drawerCTA = document.getElementById('drawer-show-results');
      if (drawerCTA) drawerCTA.textContent = `Toon ${current.length} resultaten`;
    }

    function renderFilterChips(active) {
      let chipsBox = document.getElementById('filter-chips');
      if (!chipsBox) {
        const grid = document.getElementById('products-grid');
        if (!grid || !grid.parentNode) return;
        chipsBox = document.createElement('div');
        chipsBox.id = 'filter-chips';
        chipsBox.className = 'flex flex-wrap items-center gap-2 mb-5 md:mb-6';
        chipsBox.setAttribute('aria-label', 'Actieve filters');
        grid.parentNode.insertBefore(chipsBox, grid);
      }
      const html = [];
      function addChip(label, group, value) {
        html.push(
          `<button type="button" data-chip-remove data-group="${group}" data-value="${String(value).replace(/"/g, '&quot;')}" class="inline-flex items-center gap-1.5 px-3 py-1.5 text-[12px] rounded-full bg-[color:var(--paper)] border border-[color:var(--line)] hover:border-ink transition" aria-label="Verwijder filter ${label}"><span>${label}</span><svg class="w-3 h-3" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M6 18L18 6"/></svg></button>`
        );
      }
      ['brand', 'category', 'color', 'material', 'stijl', 'type'].forEach(g => {
        (active[g] || []).forEach(v => addChip(v, g, v));
      });
      if (active.priceMin) addChip(`vanaf €${active.priceMin}`, 'priceMin', active.priceMin);
      if (active.priceMax) addChip(`tot €${active.priceMax}`, 'priceMax', active.priceMax);
      if (html.length) {
        html.push(
          `<button type="button" data-chip-clear class="inline-flex items-center gap-1 px-3 py-1.5 text-[12px] text-[color:var(--muted)] hover:text-ink transition link-draw">Filters wissen</button>`
        );
      }
      chipsBox.innerHTML = html.join('');
      chipsBox.classList.toggle('hidden', !html.length);
    }

    // Chip-remove + chip-clear handlers
    document.addEventListener('click', (e) => {
      const removeBtn = e.target.closest('[data-chip-remove]');
      if (removeBtn) {
        const group = removeBtn.dataset.group;
        const value = removeBtn.dataset.value;
        if (group === 'priceMin') {
          const el = document.getElementById('price-min');
          if (el) el.value = '';
        } else if (group === 'priceMax') {
          const el = document.getElementById('price-max');
          if (el) el.value = '';
        } else {
          document.querySelectorAll(`[data-filter="${group}"]:checked`).forEach(input => {
            if (input.value === value) input.checked = false;
          });
        }
        apply();
        return;
      }
      const clearBtn = e.target.closest('[data-chip-clear]');
      if (clearBtn) {
        document.querySelectorAll('[data-filter]:checked').forEach(i => i.checked = false);
        const pmin = document.getElementById('price-min'); if (pmin) pmin.value = '';
        const pmax = document.getElementById('price-max'); if (pmax) pmax.value = '';
        apply();
      }
    });

    document.getElementById('sort')?.addEventListener('change', apply);
    document.querySelectorAll('[data-filter], #price-min, #price-max').forEach(el => el.addEventListener('input', apply));

    document.getElementById('reset-filters')?.addEventListener('click', () => {
      document.querySelectorAll('[data-filter]').forEach(i => i.checked = false);
      document.querySelectorAll('#price-min,#price-max').forEach(i => i.value = '');
      document.querySelectorAll('[data-budget]').forEach(b => b.classList.remove('bg-ink','text-bone'));
      const s = document.getElementById('sort');
      if (s) s.value = 'relevant';
      apply();
    });

    // Initial filter pass if landed with ?sub= in URL
    if (currentSub) apply();

  } catch (err) {
    console.error(err);
  }
})();

// ==== Editorial enrichment — nu lazy-loaded via collection-editorial.js ====
function renderEditorial(slug, meta) {
  const sec = document.getElementById('col-editorial');
  if (!sec) return;
  if (window.SH?.editorial?.render) { window.SH.editorial.render(slug, meta); return; }

  // Lazy-load het editorial-bundle zodra section in viewport komt
  const load = () => {
    if (window.__SH_EDITORIAL_LOADED__) return;
    window.__SH_EDITORIAL_LOADED__ = true;
    const s = document.createElement('script');
    s.src = '/assets/collection-editorial.js';
    s.defer = true;
    s.onload = () => { window.SH?.editorial?.render?.(slug, meta); };
    document.head.appendChild(s);
  };

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach(e => { if (e.isIntersecting) { load(); obs.disconnect(); } });
    }, { rootMargin: '400px' });
    io.observe(sec);
  } else {
    load();
  }
}
